<template>
  <div class="abs hidden-sm-and-down">
    <div v-if="!$store.getters.searchBarVisible">
      <div class="myBtn pointer" @click.passive.stop="install">
        <div class="d-flex align-center">
          <v-icon class="myBlack">mdi-exit-to-app</v-icon>
          <div class="ml-2 appLabel">App speichern</div>
        </div>
        <!--            <table>-->
        <!--                <tr>-->
        <!--                    <td>-->
        <!--                        <v-icon color="white">mdi-bookmark</v-icon>-->
        <!--&lt;!&ndash;                        <img src="../assets/icons/item-plus.png">&ndash;&gt;-->
        <!--                    </td>-->
        <!--                    <td>Lesezeichen</td>-->
        <!--                </tr>-->
        <!--            </table>-->
      </div>
    </div>
  </div>
</template>

<script>
import {ebus} from '../vendor/ebus';

export default {
  name: "install",
  methods: {
    install() {
      ebus.$emit('installPrompt');
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../styles/base';

.abs {
  /*<!--z-index: -1;-->*/
  position: absolute;
  top: initial;
  bottom: -40px;
  right: 60px;
}

.myBtn {
  border-radius: $box-border-radius;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

/*.abs {*/
//    z-index: 42;
//      position: fixed;
//        top: 195px;
//        right: -99px;
// }

/*.device-xs {*/
/*    .abs {*/
/*        display: none;*/
/*    }*/

/*    !*.myBtn {*!*/
/*    !*    border-top-left-radius: 0;*!*/
/*    !*    border-top-right-radius: 0;*!*/
/*    !*}*!*/
/*}*/

.myBtn {
  @include text-contrast($color-primary);
  background-color: rgba($color-primary, 0.9);

  .appLabel {
    @include text-contrast($color-primary);
  }

  font-size: 0.9em;
  padding: 8px 20px;
  letter-spacing: 0.1em;

  border: 6px;

  display: inline-block;
}

/*img {*/
/*    width: 18px;*/
/*    height: auto;*/
/*    filter: invert(1);*/
/*}*/

/*table {*/
/*    border-collapse: collapse;*/

/*    td:first-child {*/
/*        padding-right: 8px;*/
/*        padding-top: 3px;*/
/*    }*/
/*}*/
</style>
